module.exports = __webpack_public_path__ + "assets/2272c6632c52c3e402ab27b8045ab8f1.js";